import React from 'react';

const ImportantIcon: React.FC = () => (
  <svg
    width='32'
    height='32'
    viewBox='0 0 32 32'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M17.3335 13.334H26.6668L14.6668 30.6673V18.6673H5.3335L17.3335 1.33398V13.334Z'
      fill='url(#paint0_linear_8328_60392)'
    />
    <defs>
      <linearGradient
        id='paint0_linear_8328_60392'
        x1='16.0002'
        y1='1.33398'
        x2='16.0002'
        y2='30.6673'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#00FFC2' />
        <stop offset='1' stopColor='#01D83D' />
      </linearGradient>
    </defs>
  </svg>
);

export default ImportantIcon;
